import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Seo from '../components/Seo';
const NotFoundPage = () => {
    const { t } = useTranslation();
    return (_jsxs("div", { style: {
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--text-primary)',
        }, children: [_jsx(Seo, { title: t('seo.notFound.title', 'Seite nicht gefunden'), description: "404", noindex: true }), _jsx("h2", { children: t('common.notFound', '404 – Page not found') })] }));
};
export default NotFoundPage;
